import React from "react";
import { X, Download } from 'lucide-react';
import { toast } from "react-toastify"
import AsyncSelect from "react-select/async";
import useAttachmentValidator from "../AttachmentValidator/AttachmentValidator";
import SapCsvSafeInput from "../../CommonRemarksRestriction/SapCsvSafeInput";


const VendorInvoicePopup = ({
    isOpen,
    onClose,
    invoices,
    expandedInvoice,
    setExpandedInvoice,
    popupAction,
    invoiceMode,
    taxInputValue,
    setTaxInputValue,
    loadTaxCodes,
    updateInvoice,
    vendorsData,
    setVendorsData,
    isSaving,
    isSubmitting,
    handleSubmit,
    popupType
}) => {
    const { validateAttachments } = useAttachmentValidator();
    if (!isOpen) return null;

    return (
        <>
            <div className="vendor-number-based-flow-popup">
                <div className="vendor-number-based-flow-card vendor-number-based-flow-scale">
                    <div className="vendor-number-based-flow-card-header">
                        <h2>Invoice Details</h2>
                        <div onClick={onClose} className="merged-close-btn">
                            <X size={16} />
                        </div>
                    </div>

                    <div className="vendor-number-based-flow-body">
                        {invoices.map((inv, index) => {
                            let vendorForInvoice = null;

                            vendorsData.forEach((vendor) => {
                                vendor.categories?.forEach((category) => {
                                    category.rows?.forEach((row) => {

                                        if (row.vendor_inv_number === inv.invoice_no) {
                                            vendorForInvoice = {
                                                vendor_id: vendor.vendor_id || row.vendor_id || null
                                            };
                                        }

                                    });
                                });
                            });

                            return (
                                <div
                                    key={inv.invoice_no}
                                    className="vendor-number-based-flow-accordion-item"
                                >
                                    <div
                                        onClick={() =>
                                            setExpandedInvoice(expandedInvoice === index ? null : index)
                                        }
                                        className={`vendor-number-based-flow-row-expand ${expandedInvoice === index ? "active" : ""
                                            }`}
                                    >
                                        <span className="vendor-number-based-flow-invoice-no">
                                            {inv.invoice_no}
                                        </span>
                                        <span className="vendor-number-based-flow-row-count">
                                            {inv.rows.length} GL CHARGES
                                        </span>
                                    </div>

                                    <div className="vendor-number-based-flow-accordion-body open">
                                        <div className="vendor-number-based-flow-accordion-content">
                                            <div
                                                className={`vendor-number-based-flow-form-grid ${invoiceMode === "PO" ? "full-width" : ""
                                                    }`}
                                            >
                                                {popupAction === "submit" && invoiceMode === "NON_PO" && (
                                                    <div className="vendor-number-based-flow-field" style={{ width: "100%" }}>
                                                        <label style={{ fontSize: "13px", fontWeight: 600, color: "#19324C", marginBottom: '2px' }}>
                                                            Tax Code
                                                        </label>
                                                        <AsyncSelect
                                                            value={inv.tax_code}
                                                            onChange={(selected) => updateInvoice(index, "tax_code", selected)}
                                                            inputValue={taxInputValue}
                                                            onInputChange={(value) => setTaxInputValue(value)}
                                                            loadOptions={loadTaxCodes}
                                                            menuShouldBlockScroll={true}
                                                            placeholder="Search tax code..."
                                                            cacheOptions
                                                            defaultOptions
                                                            isClearable
                                                            menuPortalTarget={document.body}
                                                            menuPlacement="auto"
                                                            styles={{
                                                                control: (base, state) => ({
                                                                    ...base,
                                                                    width: '100%',
                                                                    height: '37px',
                                                                    borderRadius: '12px',
                                                                    fontSize: '13px',
                                                                    fontFamily: 'Work Sans',
                                                                    borderColor: state.isFocused ? '#0747A6' : '#D0D6DF',
                                                                    boxShadow: state.isFocused ? '0 0 0 1px #0747A6' : 'none'
                                                                }),
                                                                container: (base) => ({ ...base, width: '100%' }),
                                                                menu: (base) => ({ ...base, fontSize: '13px', fontFamily: 'Work Sans' }),
                                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                            }}
                                                            components={{ DropdownIndicator: null, IndicatorSeparator: null }}
                                                        />
                                                    </div>
                                                )}

                                                {popupAction === "submit" && (
                                                    <div className="vendor-number-based-flow-field vendor-number-based-flow-textarea-wrapper">
                                                        <label style={{ fontSize: "13px", fontWeight: 600, color: "#19324C", marginBottom: '2px' }}>
                                                            Remarks to Vendor
                                                        </label>
                                                        <SapCsvSafeInput
                                                            as="textarea"
                                                            value={inv.remarks || ""}
                                                            onChange={(val) =>
                                                                updateInvoice(index, "remarks", val)
                                                            }
                                                            maxLength={80}
                                                            rows={1}
                                                            className="vendor-number-based-flow-textarea"
                                                            placeholder="Enter remarks..."
                                                        />
                                                        <span className="vendor-number-based-flow-char-count">
                                                            {(inv.remarks || "").length}/80
                                                        </span>
                                                    </div>
                                                )}

                                                {/* Vendor Attachment */}
                                                <div className="vendor-number-based-flow-field">
                                                    <label style={{ fontSize: "13px", fontWeight: 600, color: "#19324C" }}>
                                                        Vendor Attachment {popupAction === "submit" && (
                                                            <span style={{ color: 'red' }}>*</span>
                                                        )}
                                                    </label>

                                                    <div className="vendor-number-based-flow-file-container">
                                                        <input
                                                            type="file"
                                                            id={`vendor-attachment-${index}`}
                                                            disabled={inv.existing_vendor_attachment?.length > 0}
                                                            className="vendor-number-based-flow-file-input"
                                                            onChange={(e) => {
                                                                const files = validateAttachments(e.target.files);

                                                                if (!files.length) return;
                                                                const file = files[0];
                                                                if (!file) return;

                                                                // Store attachment with vendor association
                                                                updateInvoice(index, "vendor_attachment", {
                                                                    file: file,
                                                                    vendor_id: vendorForInvoice?.vendor_id || null,
                                                                    invoice_no: inv.invoice_no
                                                                });

                                                                if (vendorForInvoice?.vendor_id) {
                                                                    setVendorsData(prev =>
                                                                        prev.map(vendor =>
                                                                            vendor.vendor_id === vendorForInvoice.vendor_id
                                                                                ? {
                                                                                    ...vendor,
                                                                                    categories: vendor.categories.map(category =>
                                                                                        category.rows?.some(row => row.vendor_inv_number === inv.invoice_no)
                                                                                            ? {
                                                                                                ...category,
                                                                                                rows: category.rows.map(row =>
                                                                                                    row.vendor_inv_number === inv.invoice_no
                                                                                                        ? { ...row, vendor_attachment: file }
                                                                                                        : row
                                                                                                )
                                                                                            }
                                                                                            : category
                                                                                    )
                                                                                }
                                                                                : vendor
                                                                        )
                                                                    );
                                                                }
                                                            }}
                                                        />

                                                        {inv.existing_vendor_attachment?.length > 0 ? (
                                                            <a
                                                                href={inv.existing_vendor_attachment[0]}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="vendor-number-based-flow-file-display"
                                                                style={{ textDecoration: "underline", color: "#097BED" }}
                                                                title={inv.existing_vendor_attachment[0].split('/').pop()}
                                                            >
                                                                {(inv.existing_vendor_attachment[0].split('/').pop().length > 40)
                                                                    ? inv.existing_vendor_attachment[0].split('/').pop().substring(0, 40) + "..."
                                                                    : inv.existing_vendor_attachment[0].split('/').pop()
                                                                }
                                                            </a>
                                                        ) : (
                                                            <label
                                                                htmlFor={`vendor-attachment-${index}`}
                                                                className="vendor-number-based-flow-file-display"
                                                                title={inv.vendor_attachment?.file?.name || "Choose file"}
                                                            >
                                                                {inv.vendor_attachment?.file?.name
                                                                    ? (inv.vendor_attachment.file.name.length > 40
                                                                        ? inv.vendor_attachment.file.name.substring(0, 40) + "..."
                                                                        : inv.vendor_attachment.file.name)
                                                                    : "Choose file"}
                                                            </label>
                                                        )}
                                                        {inv.vendor_attachment?.file && (
                                                            <button
                                                                className="vendor-file-remove-btn"
                                                                onClick={() => {
                                                                    updateInvoice(index, "vendor_attachment", null);

                                                                    if (vendorForInvoice?.vendor_id) {
                                                                        setVendorsData(prev =>
                                                                            prev.map(vendor =>
                                                                                vendor.vendor_id === vendorForInvoice.vendor_id
                                                                                    ? {
                                                                                        ...vendor,
                                                                                        categories: vendor.categories.map(category =>
                                                                                            category.rows?.some(row => row.vendor_inv_number === inv.invoice_no)
                                                                                                ? {
                                                                                                    ...category,
                                                                                                    rows: category.rows.map(row =>
                                                                                                        row.vendor_inv_number === inv.invoice_no
                                                                                                            ? { ...row, vendor_attachment: null }
                                                                                                            : row
                                                                                                    )
                                                                                                }
                                                                                                : category
                                                                                        )
                                                                                    }
                                                                                    : vendor
                                                                            )
                                                                        );
                                                                    }
                                                                }}
                                                            >
                                                                ×
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div style={{
                                                overflowX: 'auto',
                                                whiteSpace: 'nowrap',
                                                scrollbarWidth: 'none',
                                                OverflowStyle: 'none',
                                                WebkitOverflowScrolling: 'touch',
                                                scrollBehavior: 'smooth'
                                            }}>
                                                <table className="invoice_table">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>S.NO</th>
                                                            {popupType === "glEntry" && (
                                                                <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>
                                                                    PROJECT
                                                                </th>
                                                            )}
                                                            <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>
                                                                {popupType === "glEntry" ? "JOB TYPE": "JOB.NO" }
                                                            </th>
                                                            <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>VENDOR</th>
                                                            <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>VENDOR INV NO</th>
                                                            <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>VENDOR INV DATE</th>
                                                            <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>Charge Code</th>
                                                            <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>DESCRIPTION</th>
                                                            <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>QTY</th>
                                                            <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>RATE</th>
                                                            <th style={{ backgroundColor: "#E6E9EE", textAlign: "center", padding: '10px' }}>NET TOTAL</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {inv.rows.map((row, i) => (
                                                            <tr key={i}>
                                                                <td style={{ backgroundColor: "#fff", textAlign: "center" }}>{i + 1}</td>
                                                                {popupType === "glEntry" && (
                                                                    <td style={{ backgroundColor: "#fff", textAlign: "center" }}>
                                                                        {row.project_name || "-"}
                                                                    </td>
                                                                )}
                                                                <td style={{ backgroundColor: "#fff", textAlign: "center" }}>{row.job_number || "-"}</td>
                                                                <td style={{ backgroundColor: "#fff", textAlign: "center" }}>{row.vendor_name || "-"}</td>
                                                                <td style={{ backgroundColor: "#fff", textAlign: "center" }}>{row.vendor_invoice_number}</td>
                                                                <td style={{ backgroundColor: "#fff", textAlign: "center" }}>{row.vendor_inv_date}</td>
                                                                <td style={{ backgroundColor: "#fff", textAlign: "center" }}>{row.chargecode}</td>
                                                                <td style={{ backgroundColor: "#fff", textAlign: "center" }}>{row.description}</td>
                                                                <td style={{ backgroundColor: "#fff", textAlign: "center" }}>{row.unit_of_quantity}</td>
                                                                <td style={{ backgroundColor: "#fff", textAlign: "center" }}>{row.unit_of_rate}</td>
                                                                <td style={{ backgroundColor: "#fff", textAlign: "center", padding: '10px' }}>{row.net_total}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <div className="vendor-number-based-flow-footer">
                        <button className="vendor-number-based-flow-btn-cancel" onClick={onClose}>
                            Cancel
                        </button>
                        <button
                            className="vendor-number-based-flow-btn-submit"
                            disabled={isSaving || isSubmitting}
                            onClick={() => {
                                if (popupAction === "submit") {
                                    for (const inv of invoices || []) {
                                        const hasNewFile = !!inv.vendor_attachment?.file;
                                        const hasExisting = inv.existing_vendor_attachment?.length > 0;

                                        if (!hasNewFile && !hasExisting) {
                                            toast.error(`Vendor Attachment is mandatory for Invoice ${inv.invoice_no}`);
                                            return;
                                        }
                                    }
                                }

                                onClose();
                                handleSubmit(popupAction);
                            }}
                        >
                            {popupAction === "save"
                                ? (isSaving ? "Saving..." : "Save")
                                : (isSubmitting ? "Submitting..." : "Submit")}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default VendorInvoicePopup;